const directPlacementFilters = {
  clientId: null,
  employeeName: null,
  jobTitle: null,
  isPaidInFull: null
}

export default () => Object.assign({}, directPlacementFilters)
